import { getFormattedDurationShort } from '../../../../../common/duration'
import React, { useEffect, useState } from 'react'
import { CrossClientQueryExecution } from '../../../../../models/CrossClient'

export interface CrossClientQueryQueuedProps {
  execution: CrossClientQueryExecution
}

export const CrossClientQueryQueuedInfo: React.FC<CrossClientQueryQueuedProps> = ({ execution }) => {
  const [now, setNow] = useState<Date>(new Date())

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000)
    return () => {
      clearInterval(interval)
    }
  }, [])

  return <div className='paragraph-small zocks-text-gray-700'>Queued for {getFormattedDurationShort(execution.createdAt, now.toISOString())}</div>
}
